import pos from './pos';

export default pos;
